import { render, staticRenderFns } from "./PreLogin.vue?vue&type=template&id=525f13fc&scoped=true&"
import script from "./PreLogin.vue?vue&type=script&lang=ts&"
export * from "./PreLogin.vue?vue&type=script&lang=ts&"
import style0 from "./PreLogin.vue?vue&type=style&index=0&id=525f13fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f13fc",
  null
  
)

export default component.exports